export default __webpack_public_path__ + "static/media/tracer-intro.ce22d491.mp3";